import gql from 'graphql-tag';
import { PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT } from './PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT';


const CHANGE_PRODUCT_QUEUE_TYPE = gql`
	mutation changeProductQueueType (
		$id: ID!
		$queuedProductType: Int,
	) {
		changeProductQueueType(
			id: $id
			queuedProductType: $queuedProductType,
		) {
			...planogramItemPlanogramDetail
		}
	}
	${PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT}
`;

export default CHANGE_PRODUCT_QUEUE_TYPE;

